<script>
import { mapGetters } from 'vuex';

import ProductListTableRow from './ProductListTableRow.vue';

export default {
  name: 'ProductListTable',
  components: { ProductListTableRow },
  computed: {
    ...mapGetters({
      products: 'search/products',
    }),
  },
};
</script>

<template>
  <table class="min-w-full divide-y divide-orange-diagomics-light">
    <thead class="bg-gray-50">
      <tr class="">
        <th class="w-1/3 md:w-4/12 text-left pl-2 md:pl-3 capitalize py-4">
          {{ $tc('product', 2) }}
        </th>
        <th class="w-1/3 md:w-3/12 text-left pl-2 md:pl-3 py-4">{{ $t('application') }}</th>
        <th class="w-1/3 md:w-3/12 text-left pl-2 md:pl-3 py-4">{{ $t('reactivity') }}</th>
        <th class="hidden md:table-cell md:w-2/12 text-right
          capitalize py-4 pr-2">{{ $t('compare') }}</th>
      </tr>
    </thead>
    <tbody id="products-list">
    <tr is="ProductListTableRow"
        v-for="product in products"
        :key="product.id"
        :product="product"
        class="even:bg-gray-50"
    ></tr>
    </tbody>
  </table>
</template>
